import moment from 'moment'
import React, { useCallback } from 'react'
import { ActivationObject } from '../../../providers/ActivationObjectProvider/types'
import { Step3FormProps, Step3FormOptionsProps, Step3FormConditionsProps } from '../types'
import PublicHolidaysHandle from './useStep3.publicHolidaysHandle'

const useStep3FormConditions = (
    form: Step3FormProps['form'],
    options: Step3FormOptionsProps,
    activationObject?: ActivationObject
): Step3FormConditionsProps => {
    const handoverKeys = form.watch('handoverKeys')
    const customerPresence = form.watch('customerPresence')
    const locationDog = form.watch('locationDog')
    const handoverHour = form.watch('handoverHour')
    const { setValue } = form

    React.useEffect(() => {
        // if (locationDog === 'FreeOutside' || locationDog === 'FreeInside') setValue('handoverKeys', 'NotHandoverKeys')
        if (locationDog === 'FreeOutside') setValue('handoverKeys', 'NotHandoverKeys')
        if (locationDog === 'FreeOutside') setValue('controlType', 'PerimeterControl')
    }, [locationDog, setValue])

    React.useEffect(() => {
        if (locationDog === 'FreeInside' && (handoverKeys === 'OnlyLand' || handoverKeys === 'LandAndObject'))
            setValue('controlType', 'SheathingControl')
        if ((locationDog === 'NotFree' || locationDog === 'NotPresent') && handoverKeys === 'OnlyLand')
            setValue('controlType', 'SheathingControl')
        if ((locationDog === 'NotFree' || locationDog === 'NotPresent') && handoverKeys === 'LandAndObject')
            setValue('controlType', 'InsideControl')
    }, [locationDog, handoverKeys, setValue])

    React.useEffect(() => {
        if (handoverKeys !== 'NotHandoverKeys') setValue('customerPresence', true)
        if (handoverKeys === 'NotHandoverKeys') setValue('controlType', 'PerimeterControl')
    }, [handoverKeys, setValue])

    React.useEffect(() => {
        if (handoverHour) {
            if (options.handoverTimes && !options.handoverTimes.length) {
                setValue('handoverHour', undefined)
            }
            if (options.handoverTimes && !options.handoverTimes.some((x) => x.value === handoverHour)) {
                setValue('handoverHour', options.handoverTimes.length ? options.handoverTimes[0].value : undefined)
            }
        }
    }, [activationObject, handoverHour, options.handoverTimes, setValue])

    const publicHolidays = PublicHolidaysHandle()

    const isHoliday = (currentHolidays: string[], day: Date) => {
        const formattedHolidays = currentHolidays.map((holiday) => moment(holiday).format('DD.MM.'))
        const formattedDay = moment(day).format('DD.MM.')

        return formattedHolidays.includes(formattedDay)
    }

    const now = moment()
    let handoverMinDate = now.add(now.hours() < 14 ? 1 : 2, 'day')
    if (isHoliday(publicHolidays, handoverMinDate.toDate())) handoverMinDate = handoverMinDate.add(1, 'day')
    if ((handoverMinDate.day() === 6 || handoverMinDate.day()) === 0 && (now.day() !== 4 || now.day() !== 5))
        handoverMinDate = handoverMinDate.add(2, 'day')

    const isDayDisabled = useCallback(
        (day: Date) => {
            const dateMoment = moment(day).startOf('day')
            const dow = moment(day).day()
            return (
                isHoliday(publicHolidays, day) ||
                //dow === 6 ||
                //dow === 0 ||
                options.startProtectionDays === undefined ||
                options.startProtectionDays.findIndex((x) => x.startDate.isSame(dateMoment) && x.isAvailable) === -1
            )
        },
        [options.startProtectionDays, publicHolidays]
    )

    return {
        enableCustomerPresence: handoverKeys === 'NotHandoverKeys',
        disableChippingDate: customerPresence.toString() === 'false' && handoverKeys === 'NotHandoverKeys',
        dogUnleashed: locationDog === 'FreeOutside',
        dogUnleashedInBuilding: locationDog === 'FreeInside',
        handoverMinDate: handoverMinDate.toDate(),
        isDayDisabled,
    }
}
export default useStep3FormConditions
